globalThis.Message = class Message {
  constructor(type, body, uid) {
    this.type = type;
    this.body = body;
    if (uid) this.uid = uid;
  }
};
